import { 
  ArchiveBoxXMarkIcon, 
  CalculatorIcon, 
  CheckCircleIcon,
  BookmarkSquareIcon,
  ShieldCheckIcon,
  ShieldExclamationIcon,
} from "@heroicons/react/24/outline"

import { StatCardCompact } from "@components"
import PropTypes from "prop-types"

const Stats = ({ summary = {} }) => {
  const {
    total_absent = 0,
    total_attended = 0,
    total_available = 0,
    total_booked = 0,
    total_disabled = 0,
    total_slots = 0,
  } = summary

  return (
    <div className="grid grid-cols-1 gap-5 my-5 sm:grid-cols-3 2xl:grid-cols-6">
      <StatCardCompact
        title="Total Slots"
        stat={total_slots}
        icon={<CalculatorIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Available Slots"
        stat={total_available}
        icon={<CheckCircleIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Booked Slots"
        stat={total_booked}
        icon={<BookmarkSquareIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Disabled Slots"
        stat={total_disabled}
        icon={<ArchiveBoxXMarkIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Attended Slots"
        stat={total_attended}
        icon={<ShieldCheckIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Absent Slots"
        stat={total_absent}
        icon={<ShieldExclamationIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />
    </div>
  )
}

Stats.propTypes = {
  summary: PropTypes.object,
}

export default Stats
